import * as React from "react";
import './Pick.css';
import '../components/Typograph.css';
import AppHeader from '../components/AppHeader';
import AppFooter from "../components/AppFooter";
import ImageRadioPicker from "../components/ImageRadioPicker";
import {DraaiType} from "../Model";
import ALImage from '../images/AL luik linksdraaiend.jpg'
import ARImage from '../images/AR luik rechtsdraaiend.jpg'
import BImage from '../images/B luik dubbel luik.jpg'

export default class RotatingPick extends React.Component {
    render() {
        return (
            <div className="page">
                <AppHeader title="Draai type"/>

                <div className="page-middle">
                    <h1 className="pick-title">Welk draai type is van toepassing?</h1>

                    <div className="pick-body">
                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={DraaiType.AL}
                                          image={ALImage}/>

                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={DraaiType.AR}
                                          image={ARImage}/>

                        <ImageRadioPicker onSelect={this.props.handlePageChange}
                                          current={this.props.currentValue}
                                          value={DraaiType.B}
                                          image={BImage}/>
                    </div>
                    <p className="detail-warning-text">
                        De keuzehulp kan u helaas nog niet helpen met <br/><a href="/informatie-centrum/draaitype" target="draaitypen">complexere draai situaties</a>.<br/><br/>
                        Wilt u advies over een complexere situatie?<br/>
                        Wanneer u een ander draaitype wilt toepassen, kunt u gebruik maken van de <a href="/help/offerte-aanvraag">offerte aanvraag</a>.
                    </p>
                </div>
                <AppFooter onNext={this.props.handleNextPage}
                           onPrevious={this.props.handlePreviousPage}
                           enableNext={this.props.currentValue}/>
            </div>
        );
    }
}
